import React from 'react';
import { Col, Row } from 'react-bootstrap';


const Valentinesqutes = () => {
    return (
        <Row className='p-4 d-flex align-items-center valentinesqutesrow my-4'>
        <Col className="p-4" lg={6} md={10} sm={12}>
            <h1 className="hometitle">Express your feelings with flowers</h1>
            <p>Whether you’re sending flowers to your special someone for an anniversary or birthday, expressing your well wishes for the arrival of a new baby, or saying Thank You, there are several options to show how much you care. Saying thank you to an employee, friend, family member, or teacher by sending flowers is a thoughtful gesture to show appreciation. A few bouquets that make popular Thank You flower gifts include elegant lilies, colorful rainbow roses, cheerful sunflowers, and bold tropical bouquets. Other wonderful gift ideas to say “Thank You” include beautiful potted orchids and lush green houseplants. When sending Thank You flowers, don’t forget to add a personalized card to let the recipient know how you feel and the reasons you are thankful. Trust us, it will make their day!</p>
        </Col>
    </Row>
    );
};

export default Valentinesqutes;